// Synthetic-field helpers shared between RangeBarsChart.jsx, DistributionChart.jsx,
// and CostBandTable.jsx. Pulled out on 2026-08-05 (same move as
// distributionStats.js) so CostBandTable.jsx's new per-field calculator icon
// can reuse the exact logic those two charts' tooltips already use, instead
// of a third drifting copy. Verbatim extraction, no behavior changed in
// either chart - each field/function below is byte-identical to what was
// previously declared locally in both files.

// Ported from Config.isSynthetic() (config.ts) - matches a field's synthetic
// marker by substring against the row's synthetic_data list. 'min'/'max' map
// to the percentile-band markers (annual_base10_p / annual_base90_p) since
// those are what feed Market Min/Max; 'ntr'/'exp'/'vexp' map to l1/l2/l3.
export const SYNTHETIC_FIELD_NEEDLES = {
  min: ["annual_base10_p"],
  ntr: ["l1"],
  exp: ["l2"],
  vexp: ["l3"],
  max: ["annual_base90_p"],
};

export function isSyntheticField(syntheticData, key) {
  if (!syntheticData || syntheticData.length === 0) return false;
  const needles = SYNTHETIC_FIELD_NEEDLES[key] || [];
  return needles.some((needle) =>
    syntheticData.some((entry) => entry.toLowerCase().includes(needle.toLowerCase()))
  );
}

// Ported from compensation-range-chart.component.ts's getSyntheticTooltip():
// strips the leading identifier off the matching synthetic_data entry,
// leaving just the reason text (e.g. "annual_base10_p Linear Percentage
// Data" -> "Linear Percentage Data").
export function syntheticReasonText(syntheticData, needles) {
  if (!syntheticData || syntheticData.length === 0) return "";
  for (const needle of needles) {
    const match = syntheticData.find((entry) => entry.toLowerCase().includes(needle.toLowerCase()));
    if (match) return match.replace(new RegExp(`^\\s*${needle}\\s*`, "i"), "");
  }
  return "";
}
